import { createAppKit } from "@reown/appkit/react";
import { WagmiAdapter } from "@reown/appkit-adapter-wagmi";
import { mainnet } from "@reown/appkit/networks";

const projectId =
  process.env.REACT_APP_WALLETCONNECT_PROJECT_ID ||
  "4fd1ca99d364ee964d86ea44323c2a05";

const metadata = {
  name: "flip and failures",
  description: "P&L Tracker",
  url:
    typeof window !== "undefined"
      ? window.location.origin
      : "https://www.pnl.fortunefoes.com",
  icons: ["https://fortunefoes.com/favicon.ico"],
};

const networks = [mainnet];

const wagmiAdapter = new WagmiAdapter({
  networks,
  projectId,
  ssr: false,
});

createAppKit({
  adapters: [wagmiAdapter],
  networks,
  projectId,
  metadata,
  features: {
    analytics: true,
    email: false,
    socials: false,
  },
});

export { wagmiAdapter };
